import formatCurrency from "../../../utils/formatCurrency";

export default function RelationSelector({
    label,
    options = [],
    selected = [],
    setSelected = () => { },
}) {
    const handleAdd = (item) => {
        if (!selected.find((i) => i.id === item.id)) {
            setSelected([...selected, { ...item, price: 0 }]);
        }
    };

    const handleRemove = (id) => {
        setSelected(selected.filter((item) => item.id !== id));
    };

    const handlePriceChange = (index, value) => {
        const updated = [...selected];
        updated[index].price = value;
        setSelected(updated);
    };

    return (
        <div style={{ marginTop: "1rem" }}>
            <label><strong>{label}</strong></label>
            <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                {options.map((item) => {
                    const isSelected = selected.find((i) => i.id === item.id);
                    return (
                        <button
                            key={item.id}
                            type="button"
                            disabled={isSelected}
                            onClick={() => !isSelected && handleAdd(item)}
                            style={{
                                padding: "4px 8px",
                                border: "1px solid #ccc",
                                background: isSelected ? "#e6ffe6" : "#f6f6f6",
                                color: isSelected ? "green" : "black",
                                cursor: isSelected ? "default" : "pointer",
                                borderRadius: "4px",
                            }}
                        >
                            {isSelected ? "✅ " : "+ "} {item.name}
                        </button>
                    );
                })}
            </div>

            {selected.length > 0 && (
                <div style={{ marginTop: "1rem" }}>
                    {selected.map((item, index) => (
                        <div
                            key={item.id}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "0.5rem",
                                gap: "1rem",
                            }}
                        >
                            <span>{item.name}</span>
                            <input
                                style={{ width: "200px" }}
                                className="form-control py-11"
                                type="text"
                                step="0.01"
                                min="0"
                                placeholder="Harga tambahan"
                                value={formatCurrency(item.price)}
                                onChange={(e) => handlePriceChange(index, e.target.value)}
                            />
                            <button type="button" onClick={() => handleRemove(item.id)} style={{ color: "red" }}>
                                Hapus
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
